import { createSlice, current } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import {
  getAllOutletOnlineStatus,
  getSingleOutletOnlineStatus,
  parseOutletOnlineStatus,
} from "../../helpers/outlet-status-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface OutletStatusState {
  allUsersList: [];
  allUsersMap: {};
  outletsData: {
    metaProviders: any[];
    providers: any[]
  };
  singleOutletActivityLogs: {};
  activityErrorDetails: {};
  outletOnlineStatusData: {};
  allWebhookEntities: [];
  paymentProviders: [];
}

const initialState: OutletStatusState = {
  allUsersList: [],
  allUsersMap: {},
  outletsData: {
    metaProviders: [],
    providers:[],
  },
  singleOutletActivityLogs: {},
  activityErrorDetails: {},
  outletOnlineStatusData: {},
  allWebhookEntities: [],
  paymentProviders: [],
};

export const outletStatusSlice = createSlice({
  name: "outletStatus",
  initialState,
  reducers: {
    getAllUsers: (state) => {},
    saveAllUsersData: (state, actions) => {
      state.allUsersList = actions?.payload || [];
      state.allUsersMap = actions.payload?.length
        ? convertArrayToObject(actions.payload, "businessUserId")
        : {};
    },

    getOutletsData: (state, actions) => {},
    saveOutletsData: (state, actions) => {
    state.outletsData = actions?.payload?.response || {};
      if (actions?.payload?.saveStatus)
        state.outletOnlineStatusData = getAllOutletOnlineStatus(
          actions.payload?.response?.providers
        );
    },
    saveAllOutletsStatus: (state, actions) => {
      let data = actions.payload || {};
      state.outletOnlineStatusData = { ...state.outletOnlineStatusData, data };
    },
    getOutletOnlineStatus: (state, actions) => {},
    saveOutletOnlineStatus: (state, actions) => {
      let outletCurrentStatus;
      let allOutlets = current(state)?.outletsData?.providers;
      let index = allOutlets?.findIndex(
        (outlet: any) => outlet?.id === actions.payload?.outletId
      );
      let webhookSourceType =
        index > -1 ? allOutlets[index]?.webhookSourceType : "";
      let response = actions.payload?.response;
      outletCurrentStatus = parseOutletOnlineStatus(
        response,
        actions.payload?.type,
        webhookSourceType
      );
      let dataToUpdate: any = cloneDeep(state.outletOnlineStatusData);
      if (actions.payload?.outletId) {
        dataToUpdate[actions.payload?.outletId] = getSingleOutletOnlineStatus(
          actions.payload?.outletId,
          outletCurrentStatus
        );
      }
      state.outletOnlineStatusData = dataToUpdate;
    },

    getActivityLogs: (state, actions) => {},
    saveActivityLogs: (state, actions) => {
      state.singleOutletActivityLogs = actions?.payload || {};
    },

    getActivityErrorDetails: (state, actions) => {},
    saveActivityErrorDetails: (state, actions) => {
      state.activityErrorDetails = actions?.payload || {};
    },

    toggleOutletStatus: (state, actions) => {},

    syncSingleOutletMenu: (state, actions) => {},

    outletStatusBulkUpdate: (state, actions) => {},

    outletBulkMenuSync: (state, actions) => {},

    getHelpCentreLink: (state, actions) => {},

    getOutletLogisticStatus: (state, actions) => {},
    updateOutletLogisticStatus: (state, actions) => {},

    getSelfDeliveryChargeData: (state, actions) => {},
    updateSelfDeliveryCharge: (state, actions) => {},

    getDeliveryTimings: (state, actions) => {},
    updateDeliveryTimings: (state, actions) => {},

    getSelfDeliveryTimings: (state, actions) => {},
    updateSelfDeliveryTimings: (state, actions) => {},

    getOutletConfiguration: (state, actions) => {},
    saveOutletConfiguration: (state, actions) => {},

    getAllWebhookEntities: (state, actions) => {},
    saveAllWebhookEntities: (state, actions) => {
      state.allWebhookEntities = actions.payload?.response || [];
    },

    getPaymentProviders: (state, actions) => {},
    savePaymentProviders: (state, actions) => {
      state.paymentProviders = actions.payload?.response || [];
    },
    getCurrentSyncStatus: (state,action) => {},
    getActivityDownload: (state,action) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllUsers,
  saveAllUsersData,
  getOutletsData,
  saveOutletsData,
  getOutletOnlineStatus,
  saveOutletOnlineStatus,
  getActivityLogs,
  saveActivityLogs,
  getActivityErrorDetails,
  saveActivityErrorDetails,
  toggleOutletStatus,
  syncSingleOutletMenu,
  outletStatusBulkUpdate,
  outletBulkMenuSync,
  getHelpCentreLink,
  getOutletLogisticStatus,
  updateOutletLogisticStatus,
  getSelfDeliveryChargeData,
  updateSelfDeliveryCharge,
  getDeliveryTimings,
  updateDeliveryTimings,
  getSelfDeliveryTimings,
  updateSelfDeliveryTimings,
  getOutletConfiguration,
  saveOutletConfiguration,
  getAllWebhookEntities,
  saveAllWebhookEntities,
  getPaymentProviders,
  savePaymentProviders,
  saveAllOutletsStatus,
  getCurrentSyncStatus,
  getActivityDownload
} = outletStatusSlice.actions;
export default outletStatusSlice.reducer;
